import ContinuationDate from './ContinuationDate';
import CalendarSurfaceItemBase from './itemTemplates/CalendarSurfaceItem.base';
import { getAllDayStyles } from './itemTemplates/CalendarSurfaceItem.styles';
import { observer } from 'mobx-react';
import { Icon } from 'office-ui-fabric-react/lib/Icon';
import { BaseComponent } from 'office-ui-fabric-react/lib/Utilities';
import { ControlIcons } from 'owa-control-icons';
import { differenceInMilliseconds } from 'owa-datetime';
import TimeConstants from 'owa-datetime-utils/lib/TimeConstants';
import loc from 'owa-localize';
import { noSubject } from 'owa-locstrings/lib/strings/nosubject.locstring.json';
import React from 'react';
import {
    CalendarSurfaceItemContentProps,
    CalendarSurfaceItemProps,
} from './itemTemplates/CalendarSurfaceItem.types';
import {
    renderIconWrapperAllDayItem,
    renderCharmWrapperAllDayItem,
} from './CalendarSurfaceItemComponentRenderer';

const classNames = require('classnames');
const surfaceItemStyles = require('./CalendarAllDaySurfaceItem.scss');

@observer
export default class CalendarAllDaySurfaceItem extends BaseComponent<CalendarSurfaceItemProps, {}> {
    public render() {
        const { item, itemState } = this.props;
        const hideFBBar =
            item.FreeBusyType == 'Free' || item.IsCancelled || item.ResponseType == 'Decline';
        const isMultiDay =
            differenceInMilliseconds(item.End, item.Start) > TimeConstants.MillisecondsInOneDay;
        const hideBorder =
            hideFBBar &&
            !(isMultiDay || (itemState && (itemState.continuesLeft || itemState.continuesRight)));

        return (
            <CalendarSurfaceItemBase
                {...this.props}
                onRender={this.renderContent}
                styles={getAllDayStyles}
                hideFreeBusyBar={hideFBBar}
                hideBorder={hideBorder}
            />
        );
    }

    private renderContent = (contentProps: CalendarSurfaceItemContentProps) => {
        const { item, colorScheme, charmId, itemState, allowEmptySubject } = contentProps;

        let subject = item.Subject;
        if (!subject && !allowEmptySubject) {
            subject = loc(noSubject);
        }
        return (
            <>
                <div className={classNames(surfaceItemStyles.itemContent)}>
                    {itemState && itemState.continuesLeft && (
                        <div className={classNames(surfaceItemStyles.continuationWrapper)}>
                            <Icon
                                iconName={ControlIcons.ChevronLeft}
                                className={classNames(
                                    surfaceItemStyles.icon,
                                    surfaceItemStyles.continuation
                                )}
                            />
                            <ContinuationDate date={item.Start} />
                        </div>
                    )}
                    <h2 className={surfaceItemStyles.itemSubject}>
                        {renderCharmWrapperAllDayItem(item, colorScheme, charmId)}
                        <span>{subject}</span>
                    </h2>
                </div>
                {renderIconWrapperAllDayItem(item, itemState)}
            </>
        );
    };
}
